import { config } from "../config";
import { getAuthToken } from "../util/auth";

// Templates api
export const getTemplatesApi = async () => {
    const response = await fetch(`${config.url}/forms/templates`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
    });

    if (!response.ok) {
        throw new Error('Fetching templates faild');
    }

    const resData = await response.json();
    return resData;
}

export const createNewTemplateApi = async (name, color, icon) => {
    const response = await fetch(`${config.url}/forms/create-template`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ name, color, icon })
    });

    if (!response.ok) {
        throw new Error('Create new template faild');
    }

    const resData = await response.json();
    return resData;
}

export const getBuilderFormApi = async (formId) => {
    const response = await fetch(`${config.url}/forms/form/${formId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
    });

    if (!response.ok) {
        throw new Error('Fetching builder form faild');
    }

    const resData = await response.json();
    return resData;
}

export const getFormDataByTokenApi = async (token) => {
    const response = await fetch(`${config.url}/forms/form-data-by-token/${token}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error('Fetching form data by token faild');
    }

    const resData = await response.json();
    return resData;
}

export const updateFormDataByTokenApi = async (token, formData) => {
    const response = await fetch(`${config.url}/forms/update-form-data-by-token/${token}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
    });

    if (!response.ok) {
        throw new Error('Update form faild');
    }

    const resData = await response.json();
    return resData;
}

export const saveFormAsPdfFileByTokenApi = async (token, formData) => {
    const response = await fetch(`${config.url}/forms/save-form-as-pdf-file-by-token/${token}`, {
        method: 'POST',
        body: formData
    });

    if (!response.ok) {
        throw new Error('Update form faild');
    }

    const resData = await response.json();
    return resData;
}

export const uploadRequestedFileByTokenApi = async (token, reqFileId, formData) => {
    const response = await fetch(`${config.url}/forms/upload-requested-file-by-token/${token}/${reqFileId}`, {
        method: 'POST',
        body: formData
    });

    if (!response.ok) {
        throw new Error('Upload requested file faild');
    }

    const resData = await response.json();
    return resData;
}

export const deleteTokenByTokenApi = async (token) => {
    const response = await fetch(`${config.url}/forms/delete-token-by-token/${token}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error('Delete token faild');
    }

    const resData = await response.json();
    return resData;
}

// Forms api
export const getFormsApi = async () => {
    const response = await fetch(`${config.url}/forms/forms`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
    });

    if (!response.ok) {
        throw new Error('Fetching forms faild');
    }

    const resData = await response.json();
    return resData;
}

export const createNewFormApi = async (name, color, icon) => {
    const response = await fetch(`${config.url}/forms/create-form`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ name, color, icon })
    });

    if (!response.ok) {
        throw new Error('Create new form faild');
    }

    const resData = await response.json();
    return resData;
}

export const createNewFormFromTemplateApi = async (name, templateId) => {
    const response = await fetch(`${config.url}/forms/create-form-from-template`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ name, templateId })
    });

    if (!response.ok) {
        throw new Error('Create new form from template faild');
    }

    const resData = await response.json();
    return resData;
}

// Shared api
export const deleteTemplateOrFormApi = async (id) => {
    const response = await fetch(`${config.url}/forms/delete-template-or-form/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
    });

    if (!response.ok) {
        throw new Error('Delete template or form faild');
    }

    const resData = await response.json();
    return resData;
}

export const updateFormOrTemplateApi = async (id, formData) => {
    const response = await fetch(`${config.url}/forms/update-form-or-template/${id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify(formData)
    });

    if (!response.ok) {
        throw new Error('Update template faild');
    }

    const resData = await response.json();
    return resData;
}

export const uploadRequestedFile = async (formId, reqFileId, formData) => {
    const response = await fetch(`${config.url}/forms/upload-requested-file/${formId}/${reqFileId}`, {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: formData
    });

    if (!response.ok) {
        throw new Error('Upload requested file faild');
    }

    const resData = await response.json();
    return resData;
}

export const createObjectIdApi = async () => {
    const response = await fetch(`${config.url}/create-objectid`, {
        method: 'Get',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        }
    });

    if (!response.ok) {
        throw new Error('Create objectid faild');
    }

    const resData = await response.json();
    return resData;
}